import React, { useId, useRef } from 'react';
import RichText from '../Global/RichText';
import { getColor, getMultiChoice } from '../Global/DataUtils/index';
import CtaLink from '../Global/CtaLink';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/virtual';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { LinkedAlert } from '.';
import * as styles from './multi-alert-banner.module.css';
import {
    KontentNumberValue,
    KontentRadioMultiChoice,
} from '../../../types/KontentProps';
import { reorderUrl } from '../../global/reorderUrl';

interface Props {
    alerts: any[];
    cycle_between_alerts?: KontentRadioMultiChoice<'yes' | 'no'>;
    time_between_alerts?: KontentNumberValue;
}
const BannerCycle: React.FC<Props> = ({
    cycle_between_alerts,
    time_between_alerts,
    alerts,
}) => {
    const cycleBtwAlert =
        getMultiChoice(cycle_between_alerts) == 'yes' ? true : false;
    const swiperRef = useRef<any>(null);
    const timeBtwAlert = time_between_alerts?.value || 5;
    const uniqueId = useId();
    const safeId = `alert-${uniqueId.replace(/[:]/g, '')}`;
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const renderAlerts = (alert: LinkedAlert, alertIdx: number) => {
        let barColor = getColor(alert?.elements?.bar_color) || '#f06623';
        let fontColor = getColor(alert?.elements?.font_color) || '#fff';
        const ctaLocationUrl =
            alert?.elements?.cta_configuration__cta_location?.value?.[0]
                ?.elements?.slug?.url ||
            alert?.elements?.cta_configuration__cta_location?.value?.[0]
                ?.elements?.third_party_url?.value ||
            alert?.elements?.cta_configuration__cta_location?.value?.[0]
                ?.elements?.document?.value[0]?.url ||
            alert?.elements?.cta_configuration__cta_location?.value?.[0]
                ?.elements?.file?.value[0]?.url;
        if (
            alert?.elements?.cta_configuration__cta_label?.value ||
            ctaLocationUrl
        ) {
            const ctaWindowAction = getMultiChoice(
                alert.elements.cta_configuration__cta_window_action
            );
            var ctaTarget =
                ctaWindowAction === 'new_window' ? '_blank' : '_self';
            const ctaAnchor =
                alert?.elements?.cta_configuration__cta_location_anchor_point;
            var ctaHref = BuildLinkHref(
                alert?.elements?.cta_configuration__cta_location,
                ctaAnchor
            );
            if (typeof window !== 'undefined' && window.location.search) {
                const hasQuery = ctaHref.includes('?');
                ctaHref += hasQuery
                    ? '&' + window.location.search.substring(1)
                    : window.location.search;
            }
        }

        const MultiAlertBannerContent = (
            <div
                className={styles.alert}
                key={alertIdx}
                style={{ backgroundColor: barColor, color: fontColor }}
            >
                {RichText(
                    alert.elements.message,
                    undefined,
                    undefined,
                    undefined,
                    'message'
                )}

                {alert.elements?.cta_configuration__cta_label?.value && (
                    <div className={styles.alertChild}>
                        {alert?.elements.cta_configuration__cta_label?.value ? (
                            <style>{`#alert-cta-link-${alertIdx}:hover { 
                            border-color: ${fontColor} !important; 
                            color: ${barColor} !important;
                            background-color: ${fontColor} !important;
                        }`}</style>
                        ) : (
                            <></>
                        )}
                        {alert?.elements?.cta_configuration__cta_label
                            ?.value && (
                            <CtaLink
                                color={fontColor}
                                hoverBgColor={fontColor}
                                hoverFontColor={barColor}
                                id={`alert-cta-link-${alertIdx}`}
                                href={reorderUrl(ctaHref)}
                                target={ctaTarget}
                            >
                                {
                                    alert.elements?.cta_configuration__cta_label
                                        ?.value
                                }
                            </CtaLink>
                        )}
                    </div>
                )}
            </div>
        );
        return ctaLocationUrl ? (
            <a
                style={{ width: '100%' }}
                href={reorderUrl(ctaHref)}
                target={ctaTarget}
                rel={ctaTarget === '_blank' ? 'noopener noreferrer' : undefined}
            >
                {MultiAlertBannerContent}
            </a>
        ) : (
            MultiAlertBannerContent
        );
    };

    const handleSwiperInit = (swiper: any) => {
        if (cycleBtwAlert) {
            swiper.autoplay?.start();
        }
    };
    return (
        <div>
            <style>{`
                .containerD {
                    position: relative;
                }

                .containerD .swiper {
                    margin: 0;
                }

                .containerD .showcaseSwiper {
                    width: 100%;
                }

                .containerD .nextt {
                    margin-top: 0px;
                    position: absolute;
                    top: 50%;
                    right: 0px;
                    width: 45px;
                    height: 30px;
                    transform: translateY(-50%);
                }

                @media screen and (min-width: 576px) {
                    .containerD .nextt {
                        right: 40px !important;
                    }
                }

                .containerD .nextt::after {
                    font-size: 30px;
                    z-index: 999999999 !important;
                }

                .containerD .prevv {
                    position: absolute;
                    top: 50%;
                    left: 0px;
                    width: 45px;
                    height: 30px;
                    transform: translateY(-50%);
                    margin-top: 0px;
                }

                @media screen and (min-width: 576px) {
                    .containerD .prevv {
                        left: 40px !important;
                    }
                }

                    .containerD .prevv::after {
                    font-size: 30px;
                    z-index: 999999999 !important;
                }

                @media screen and (max-width: 576px) {
                    .containerD .nextt,
                    .containerD .prevv {
                        width: 36px;
                        height: 36px;
                    }

                    .containerD .nextt::after,
                    .containerD .prevv::after {
                        font-size: 22px;
                    }
                }

                .containerD .swiper:not(.swiper-initialized) .swiper-slide ~ .swiper-slide {
                    display: none !important;
                }

                .containerD .swiper:not(.swiper-initialized) ~ .nextt,
                .containerD .prevv:has(~ .swiper:not(.swiper-initialized)) {
                    visibility: hidden;
                }
            `}</style>

            <div className="containerD">
                <div
                    className="swiper-button-prev prevv"
                    id={`swiper-prev-${safeId}`}
                    ref={prevRef}
                ></div>
                <Swiper
                    ref={swiperRef}
                    className="showcaseSwiper"
                    modules={[Navigation, Pagination, Autoplay]}
                    onSwiper={handleSwiperInit}
                    centerInsufficientSlides
                    spaceBetween={0}
                    navigation={{
                        nextEl: `#swiper-next-${safeId}`,
                        prevEl: `#swiper-prev-${safeId}`,
                    }}
                    scrollbar={{ draggable: true }}
                    autoplay={
                        cycleBtwAlert ? { delay: timeBtwAlert * 1000 } : false
                    }
                    speed={2000}
                    loop={true}
                >
                    {alerts?.length > 0 &&
                        alerts?.map((LinkedAlert, alertIdx) => {
                            let barColorBkg = getColor(
                                LinkedAlert.elements.bar_color
                            );
                            let arrowColor =
                                barColorBkg === '#f5f4f2' ||
                                barColorBkg === '#ffffff'
                                    ? 'black !important'
                                    : 'white !important';
                            return (
                                <SwiperSlide
                                    virtualIndex={alertIdx}
                                    key={alertIdx}
                                    className="slideCustom"
                                >
                                    <section
                                        className={styles.banner}
                                        style={{
                                            backgroundColor:
                                                barColorBkg || '#f06623',
                                        }}
                                    >
                                        <style>
                                            {`
                                                .prevv {
                                                    color: ${arrowColor};
                                                    z-index: 999999999 !important;
                                                }
                                                .nextt {
                                                    color: ${arrowColor};
                                                    z-index: 999999999 !important;
                                                }                                                  
                                                `}
                                        </style>
                                        {renderAlerts(LinkedAlert, alertIdx)}
                                    </section>
                                </SwiperSlide>
                            );
                        })}
                </Swiper>
                <div
                    className="swiper-button-next nextt"
                    id={`swiper-next-${safeId}`}
                    ref={nextRef}
                ></div>
            </div>
        </div>
    );
};

export default BannerCycle;
